import { createAction, emptyProps, props } from "@ngrx/store";

export const FETCH_STAGE_MASTER = createAction(
    'FETCHSTAGEMASTER',
    emptyProps
);

export const FETCH_STAGE_MASTER_SUCCESS = createAction(
  'FETCH_STAGE_MASTER_SUCCESS',
  props<{ stages: any }>()
);
